/* eslint-disable no-console */
import { post } from './httpRequest';

export const sendBeacon = (url: string, data: unknown): boolean => {
  if (navigator.sendBeacon) {
    const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
    return navigator.sendBeacon(url, blob);
  }
  post(url, data, {});
  return false;
};
